<template>
    <div>
        <a-card>
            <!--    有多个包组    -->
            <div v-if="result && result.length >0">
                <h1 class="text-center color-main">采购结果通知</h1>
                <div class="border p-5 color-black size3">
                    <div class="size3">{{supplierName|| ''}} :</div>
                    <div class="p-5 ml-5">
                        <div class="mb-5">{{projectName}}项目（项目编号：{{projectCode}}）已结束，贵单位所参与包组的结果如下：</div>
                        <div v-for="it in result">
                            <div class="mt-5">{{it.bzmc}}: {{it.bzxh}}</div>
                            <!--                        是否存在采购结果-->
                            <template v-if="it.jgqrId">
                                <div class="mt-2" v-if="it.cgjg === '1'">
                                    <!--                                是否中标-->
                                    <template v-if="it.zbId">
                                        贵单位成交，
                                        <template v-if="'1' ===jcxm">
                                            <template v-if="it.zbxx">
                                                {{it.zbxx}}
                                            </template>
                                            <template v-else>
                                                成交金额：{{it.zbje}}元
                                            </template>
                                        </template>
                                        <template v-else>
                                            成交金额：
                                            <template v-if="'1' !==it.bjlx">
                                                按{{it.bjLxText}}计算
                                            </template>
                                            <template v-else>
                                                {{it.zbje}}元
                                            </template>
                                        </template>
                                    </template>
                                    <template v-else>
                                        <div class="mt-2">贵单位未能成交。</div>
                                    </template>
                                </div>
                                <template v-else>
                                    <div class="mt-2">{{it.sbqkms}}</div>
                                </template>
                            </template>
                            <template v-else>
                                <div class="mt-2">
                                    <p class="size2 mt-3 color-ash">采购结果未发布,请耐心等待</p>
                                </div>
                            </template>
                        </div>
                        <p class="mt-2">感谢贵单位对本次采购工作的支持！</p>
                    </div>
                    <div class="text-right">
                        广东志正招标有限公司
                    </div>
                </div>
            </div>
            <div class="text-center" style="margin: 40px 0" v-else>
                <img style="margin: auto;width: 90px" src="../../img/empty4.png">
                <p class="size2 mt-3 color-ash">采购结果未发布,请耐心等待</p>
            </div>
        </a-card>
    </div>
</template>

<script>
  import UploadSelector from '@/components/selector/UploadSelector'
  import qs from 'qs'

  export default {
    name: 'LegalResult',
    props: {
      projectId: {
        type: String,
        required: true
      },
      currentSupplierId: {
        type: String,
        required: true
      },
      random: {
        type: String,
        default: '',
        required: false
      }
    },
    components: {
      UploadSelector
    },
    created () {
      this.successConfirmId = this.projectId + this.currentSupplierId
      console.log(this.successConfirmId)
      this.initData()
    },
    watch: {
      random: {
        immediate: false,
        handler (newValue, oldValue) {
          if (newValue !== oldValue) {
            console.log('has listened data!')
            this.initData()
          }
        }
      }
    },

    data () {
      return {
        bondList: [],
        current: 1,
        pageList: [],
        supplierName: '',
        bondMoney: '1000',
        projectName: '电脑采购项目',
        projectCode: 'COMPUTER-CODE-ONE-0001',
        openDate: '2020-07-10',
        result: {},
        packs: '',
        state: '0',
        successPackList: '',
        successConfirmId: '', //业务ID 项目+供应商ID
        jcxm:'',
      }
    },
    methods: {
      initData () {
        let that = this
        this.$http.get('/api/v1/supplier/LegalResult/get_result.json?projectId=' + this.projectId).then(function (res) {
          if (res.code === 200) {
            if (res.result) {
              that.result = res.result.legalResult
              that.supplierName = res.result.supplierName
              that.projectName = res.result.xmmc
              that.projectCode = res.result.xmbh
              that.jcxm = res.result.jcxm
            } else {
              console.log('暂无结果,请耐心等待')
            }
          }
        })
      },
      downTmp () {
        let that = this
        this.$http.post('/api/v1/supplier/result/get_confirm_template.json', qs.stringify(this.initData), {
          responseType: 'blob'
        }).then(res => {
          let blob = new Blob([res], {
            type: 'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })
          if (window.navigator.msSaveOrOpenBlob) {
            var fileName = '.xls'
            navigator.msSaveBlob(blob, fileName)
          } else {
            let elink = document.createElement('a')
            elink.download = '成交报价确认函.docx'
            elink.style.display = 'none'
            elink.href = URL.createObjectURL(blob)
            document.body.appendChild(elink)
            elink.click()
            document.body.removeChild(elink)
          }
        }).catch(err => {
          console.warn(err)
        })
      },

      //supplierName
      uploadSelectorChange (fileLength) {
        let that = this

        if (fileLength) {
          const user = this.$ls.get('user')
          //console.log(111);
          if (this.result && this.result.projectName && user.supplierName) {
            let title = '项目消息'
            let content = user.supplierName + '已上传了' + this.result.projectName + '的《成交报价确认函》，请注意查看。'
            this.$http.get('/api/v1/supplier/bid/send_msg_in_project.json?id=' + this.projectId + '&title=' + title + '&content=' + content).then(function (res) {

            })
          }
        }
      }
    }
  }
</script>

<style scoped>
    a {
        text-decoration: underline;
    }

    /deep/ .file_list {
        background: #f7f7f7;
        margin-top: 12px;
        padding: 12px 16px;
        border-bottom: none;
    }
</style>
